<template>
  <el-card class="form-container" shadow="never" :loading="loading">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="changepasswordruleForm"
             label-width="150px">
      <el-form-item label="原密码：" prop="oripassword">
        <el-input type="password" v-model="ruleForm.oripassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newpassword">
        <el-input type="password" v-model="ruleForm.newpassword"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="configpassword">
        <el-input type="password" v-model="ruleForm.configpassword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="home.changepasswordDialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {changepassword} from '@/api/login'
const bcryptjs = require('bcryptjs')
export default {
  name: 'changePassword',
  props: ['home', 'username'],
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.newpassword !== '') {
          this.$refs.changepasswordruleForm.validateField('password')
        }
        callback()
      }
    }
    var validateOripassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入源密码'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newpassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        oripassword: '',
        newpassword: '',
        configpassword: ''
      },
      loading: false,
      selectMenuList: [],
      rules: {
        oripassword: [
          {validator: validateOripassword, trigger: 'blur'}
        ],
        newpassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        configpassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm () {
      let _this = this
      this.$refs.changepasswordruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let password = bcryptjs.hashSync(_this.ruleForm.configpassword, 10)
          changepassword(_this.username, _this.ruleForm.oripassword, password).then(response => {
            if (response.data === '200') {
              _this.$message({
                message: '修改成功！',
                type: 'success'
              })
              this.loading = false
              this.home.changepasswordDialogVisible = false
            } else {
              _this.$message({
                message: response.message,
                type: 'error'
              })
              this.loading = false
            }
          }).catch(error => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/manage/components/changePassword.vue